import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";
import { UsersThree } from "@phosphor-icons/react";

export default function Coordonare() {
  const [board, setBoard] = useState(null);
  const [sel, setSel] = useState({});

  const load = () => api.get("/coordinator/board").then((r) => setBoard(r.data.board || [])).catch(() => setBoard([]));
  useEffect(() => { load(); }, []);

  const allocate = async (dept, pid) => {
    const memberId = sel[pid];
    if (!memberId) { toast.error("Alege o persoană"); return; }
    try {
      const { data } = await api.post(`/departments/${dept}/allocate`, { project_id: pid, assignee_id: memberId });
      toast.success(`Alocat către ${data.assignee}`);
      setSel((s) => { const n = { ...s }; delete n[pid]; return n; });
      load();
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
  };

  if (!board) return <div className="p-8 text-muted-foreground">Se încarcă…</div>;

  return (
    <div className="space-y-6" data-testid="coordonare-page">
      <div className="flex items-center gap-3">
        <UsersThree size={28} weight="bold" className="text-primary" />
        <div>
          <h1 className="font-head text-3xl font-bold">Coordonare</h1>
          <p className="text-sm text-muted-foreground">Proiecte ajunse la departamentul tău, încă nealocate unui membru. Alege persoana și alocă dintr-un click.</p>
        </div>
      </div>

      {board.length === 0 && (
        <div className="rounded-xl border border-border bg-card p-8 text-center text-muted-foreground" data-testid="coordonare-empty">
          Nu coordonezi niciun departament sau nu ai proiecte de alocat momentan.
        </div>
      )}

      {board.map((b) => (
        <div key={b.dept} className="rounded-xl border border-border bg-card p-6" data-testid={`coord-dept-${b.dept}`}>
          <div className="mb-3 flex items-center justify-between gap-3">
            <h2 className="font-head text-xl font-bold">{b.label}</h2>
            <span className="rounded-full bg-amber-500/15 px-2.5 py-0.5 text-xs font-bold text-amber-300">{b.projects.length} nealocate</span>
          </div>
          {b.projects.length === 0 ? (
            <p className="text-sm text-emerald-300">Toate proiectele sunt alocate. 🎉</p>
          ) : (
            <div className="space-y-2">
              {b.projects.map((p) => (
                <div key={p.id} className="flex flex-wrap items-center gap-3 rounded-lg border border-border px-3 py-2.5" data-testid={`coord-proj-${p.id}`}>
                  <div className="min-w-0 flex-1">
                    <Link to={`/projects/${p.id}`} className="font-semibold hover:text-primary">{p.code}</Link>
                    <div className="truncate text-xs text-muted-foreground">{p.name} · etapa {(p.wf_stage || 0) + 1}/12</div>
                  </div>
                  <Select value={sel[p.id] || ""} onValueChange={(v) => setSel((s) => ({ ...s, [p.id]: v }))}>
                    <SelectTrigger className="h-9 w-56" data-testid={`coord-member-${p.id}`}><SelectValue placeholder="Alege persoana…" /></SelectTrigger>
                    <SelectContent>{b.members.map((m) => <SelectItem key={m.id} value={m.id}>{m.name}</SelectItem>)}</SelectContent>
                  </Select>
                  <Button size="sm" onClick={() => allocate(b.dept, p.id)} disabled={!sel[p.id]} data-testid={`coord-alloc-${p.id}`}>Alocă</Button>
                </div>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
